export enum DocumentTags {
  LANGUAGE_TEST = 'LANGUAGE_TEST',
  LANGUAGE_TEST_IELTS = 'LANGUAGE_TEST_IELTS',
  LANGUAGE_TEST_PTE = 'LANGUAGE_TEST_PTE',
  LANGUAGE_TEST_TOEFL = 'LANGUAGE_TEST_TOEFL',
  LANGUAGE_TEST_DUOLINGO = 'LANGUAGE_TEST_DUOLINGO',
  LANGUAGE_TEST_CAEL = 'LANGUAGE_TEST_CAEL',
  LANGUAGE_TEST_MET = 'LANGUAGE_TEST_MET',
  LANGUAGE_TEST_CAMBRIDGE = 'LANGUAGE_TEST_CAMBRIDGE',
  LANGUAGE_TEST_EPP = 'LANGUAGE_TEST_EPP',
  LANGUAGE_TEST_OTHER = 'LANGUAGE_TEST_OTHER',
  LANGUAGE_TEST_CANTEST = 'LANGUAGE_TEST_CANTEST',
  LANGUAGE_TEST_LANGUAGECERT_ESOL = 'LANGUAGE_TEST_LANGUAGECERT_ESOL',
  LANGUAGE_TEST_LEAP_4_ADVANCED = 'LANGUAGE_TEST_LEAP_4_ADVANCED',
  TRANSCRIPTS = 'TRANSCRIPTS',
  CERTIFICATE = 'CERTIFICATE',
  PASSPORT = 'PASSPORT',
  STUDY_PERMIT = 'STUDY_PERMIT',
  WORK_PERMIT = 'WORK_PERMIT',
  REFUGEE = 'REFUGEE',
  REFUGEE_CLAIMANT = 'REFUGEE_CLAIMANT',
  VISITOR_TOURIST_VISA = 'VISITOR_TOURIST_VISA',
  DESTINATION_COUNTRY_STATUS = 'DESTINATION_COUNTRY_STATUS',
  STATEMENT_OF_PURPOSE = 'STATEMENT_OF_PURPOSE',
  LETTER_OF_RECOMMENDATION = 'LETTER_OF_RECOMMENDATION',
  CONSENT_FORM = 'CONSENT_FORM',
  GMAT_SCORE = 'GMAT_SCORE',
  GRE_SCORE = 'GRE_SCORE',
  RESUME = 'RESUME',
  EMPLOYMENT_LETTER = 'EMPLOYMENT_LETTER',
  VOLUNTEER_LETTER = 'VOLUNTEER_LETTER',
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  WES_EVALUATION_REPORT = 'WES_EVALUATION_REPORT',
  PORTFOLIO = 'PORTFOLIO',
  FINANCIAL_PROOF = 'FINANCIAL_PROOF',
  ADDITIONAL_DOCUMENT = 'ADDITIONAL_DOCUMENT',
  PRE_OFFER_LETTER = 'PRE_OFFER_LETTER',
  DECLINED_LETTER = 'DECLINED_LETTER',
  TUITION_DEPOSIT_RECEIPT = 'TUITION_DEPOSIT_RECEIPT',
  VISA_OUTCOME = 'VISA_OUTCOME',
  IQAS_ASSESSMENT = 'IQAS_ASSESSMENT',
  CASPER_TEST_SCORE_REPORT = 'CASPER_TEST_SCORE_REPORT',
  SNAPSHOT = 'SNAPSHOT',
  PROOF_OF_NAME_CHANGE = 'PROOF_OF_NAME_CHANGE',
  RELEASE_OF_INFORMATION_FORM = 'RELEASE_OF_INFORMATION_FORM',
  AUTHORIZED_RP_RELEASE_OF_INFORMATION_FORM = 'AUTHORIZED_RP_RELEASE_OF_INFORMATION_FORM',
  NURSING_LICENSE = 'NURSING_LICENSE',
  // The below are reliant on applications-lib implementation
  FINAL_OFFER_LETTER = 'FINAL_OFFER_LETTER',
  WAITLIST_LETTER = 'WAITLIST_LETTER',
}

export enum DecisionType {
  PRE_OFFER = 'preOfferDecision',
  FINAL_OFFER = 'finalOfferDecision',
  WAITLIST = 'waitlistDecision',
}

export enum ConditionType {
  PRE_OFFER = 'preOfferConditions',
  FINAL_OFFER = 'finalOfferConditions',
  WAITLIST = 'waitlistConditions',
}

export enum StudentDecisionResponse {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type DecisionDocumentTags =
  | DocumentTags.PRE_OFFER_LETTER
  | DocumentTags.WAITLIST_LETTER
  | DocumentTags.FINAL_OFFER_LETTER
  | DocumentTags.DECLINED_LETTER

export type AdditionalDocumentTags = Extract<
  DocumentTags,
  | DocumentTags.STATEMENT_OF_PURPOSE
  | DocumentTags.LETTER_OF_RECOMMENDATION
  | DocumentTags.CONSENT_FORM
  | DocumentTags.GMAT_SCORE
  | DocumentTags.GRE_SCORE
  | DocumentTags.RESUME
  | DocumentTags.EMPLOYMENT_LETTER
  | DocumentTags.VOLUNTEER_LETTER
  | DocumentTags.ADDITIONAL_DOCUMENT
  | DocumentTags.BIRTH_CERTIFICATE
  | DocumentTags.WES_EVALUATION_REPORT
  | DocumentTags.PORTFOLIO
  | DocumentTags.FINANCIAL_PROOF
  | DocumentTags.IQAS_ASSESSMENT
  | DocumentTags.CASPER_TEST_SCORE_REPORT
  | DocumentTags.SNAPSHOT
  | DocumentTags.PROOF_OF_NAME_CHANGE
  | DocumentTags.RELEASE_OF_INFORMATION_FORM
  | DocumentTags.AUTHORIZED_RP_RELEASE_OF_INFORMATION_FORM
  | DocumentTags.NURSING_LICENSE
>

export enum DestinationCountryStatus {
  NO_STATUS = 'NO_STATUS',
  WORK_PERMIT = 'WORK_PERMIT',
  VISITOR = 'VISITOR',
  STUDY_PERMIT = 'STUDY_PERMIT',
  REFUGEE = 'REFUGEE',
  REFUGEE_CLAIMANT = 'REFUGEE_CLAIMANT',
  OTHER = 'OTHER',
}

export enum LanguageExam {
  IELTS = 'IELTS',
  PTE = 'PTE',
  TOEFL = 'TOEFL',
  DUOLINGO = 'DUOLINGO',
  OTHER = 'OTHER',
}

export enum LanguageExamAvailability {
  HAVE = 'HAVE',
  DONT_NEED = 'DONT_NEED',
  WILL_HAVE = 'WILL_HAVE',
}

export enum RelationshipType {
  PARENT = 'PARENT',
  GUARDIAN = 'GUARDIAN',
  FRIEND = 'FRIEND',
  SPOUSE = 'SPOUSE',
  RELATIVE = 'RELATIVE',
  OTHER = 'OTHER',
}

export enum EducationLevel {
  PRIMARY_SCHOOL = 'PRIMARY_SCHOOL',
  MIDDLE_SCHOOL = 'MIDDLE_SCHOOL',
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  UNDERGRAD = 'UNDERGRAD',
  GRADUATE = 'GRADUATE',
  PHD = 'PHD',
}

export enum EducationLevelLabels {
  PRIMARY_SCHOOL = 'Elementary / Primary',
  MIDDLE_SCHOOL = 'Junior Secondary / Middle School',
  HIGH_SCHOOL = 'Senior Secondary / High School',
  UNDERGRAD = 'Undergraduate',
  GRADUATE = 'Graduate',
  PHD = 'Doctorate',
}

export enum TimelineTabs {
  PERSONAL_INFORMATION = 2,
  CONTACT_INFORMATION = 3,
  EDUCATION_HISTORY = 4,
  LANGUAGE_PROFICIENCY = 5,
  OTHER_REQUIRED_DOCUMENTS = 6,
}

export enum ApplicationSteps {
  PROGRAM_SELECT = 0,
  ALTERNATE_PROGRAM_SELECT = 1,
  PERSONAL_INFORMATION = 2,
  CONTACT_INFORMATION = 3,
  EDUCATION_HISTORY = 4,
  LANGUAGE_PROFICIENCY = 5,
  OTHER_REQUIRED_DOCUMENTS = 6,
}
